import MonacoEditor from '@monaco-editor/react';
import { Box } from '@mui/material';
import type React from 'react';

const MONACO_THEME_BG_COLOR = '#1C1C1C';

export type CodeBlockOwnProps = {
  readonly code: string;
  readonly language?: string;
  readonly lineNumbers?: boolean;
  /**
   * Allow the user to resize the code block vertically.
   */
  readonly resizable?: boolean;
  readonly width?: string;
  readonly height?: string;
  /**
   * Automatically set the initial height based on the number of lines displayed.
   */
  readonly autoHeight?: boolean;
};

export type CodeBlockHookProps = {
  readonly computedHeight: string;
};

export type CodeBlockProps = CodeBlockOwnProps & CodeBlockHookProps;

export const CodeBlock: React.FC<CodeBlockProps> = (props: CodeBlockProps): JSX.Element => {
  const { code, language, lineNumbers, resizable, width = '100%', computedHeight } = props;

  return (
    <Box
      sx={{
        overflow: 'hidden',
        resize: resizable ? 'vertical' : 'none',
        height: computedHeight,
        my: 0.5,
        pt: 2.5,
        pb: 0.5,
        bgcolor: MONACO_THEME_BG_COLOR,
        borderRadius: 1
      }}
    >
      <MonacoEditor
        width={width}
        height="100%"
        theme="vs-dark"
        defaultLanguage={language}
        defaultValue={code}
        options={{
          readOnly: true,
          lineNumbers: lineNumbers ? 'on' : 'off',
          automaticLayout: true,
          scrollBeyondLastLine: false,
          minimap: {
            enabled: false
          }
        }}
      />
    </Box>
  );
};
